// src/Pages/Unauthorized.js
import React from "react";

const Unauthorized = () => (
  <div className="flex flex-col items-center justify-center min-h-screen">
    <h1 className="text-4xl font-bold text-red-600">403 - Unauthorized</h1>
    <p className="text-lg mt-4">You do not have permission to view this page.</p>
  </div>
);

export default Unauthorized;
